<template>
  <div>
    <h1 id="jump-to-header">{{heading || "Update"}}</h1>
    <polymorphic-reference-update :id="id"/>
  </div>
</template>

<script>
import PolymorphicReferenceUpdate from './PolymorphicReferenceUpdate.vue'

export default {
  components: {
    PolymorphicReferenceUpdate
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>